export class SiteFeatures {
  showBlastDesignTab: boolean = true;
  showBlastLoadTab: boolean = true;
  show3dViewerTab: boolean = true;
  showDeliveriesTab: boolean = true;
  showVibrationsTab: boolean = true;
  showFragmentationTab: boolean = true;
  showLoadAndHaulTab: boolean = false;
  showFleetManagementSystemTab: boolean = false;
  showEnvironmentTab: boolean = true;
}
